import {ref} from 'vue'

const lang = ref({
    cn:'s',
    eng:false
})
export default lang 
export { lang } 